<template lang="pug">
.room-view(@click="goto",
  :class='[{disable: !room.avaliable, empty: empty, delegated}, "expiring-level" + level]')
  .no {{room.no}}

  .right-corner-icons
    el-tooltip(placement='top', :disabled='$media.isMobile || !tracking_notes_unchecked.length')
      div(slot='content')
        .item(v-for='item in tracking_notes_unchecked')
          span {{item.note}}

      .quick-note(
        @click.stop='$emit("tracking-notes", room)',
        :class='{active: tracking_notes_unchecked.length}'
      )
        i.icon(:class='tracking_notes_unchecked.length ? "sticky note" : "sticky note outline"')

    .preorderable(v-if='contract && contract.preorderable === 1', data-tooltip='可预订', data-position='top center', data-inverted="")
      i.icon.pin
    .preorderable(v-if='contract && contract.preorderable === 2', data-tooltip='确认续租', data-position='top center', data-inverted="")
      i.icon.checkmark

    .persons(v-if='persons', :data-tooltip='$media.isMobile ? null : $formatters.customers_summary(customers)', data-position='top center', data-inverted="")
      i.mi {{persons>1?'people':'person'}}
      span {{persons}}

  .prices(:class='{shifted:preorders.length}')
    .per_month {{room.price_month}}
    //.per_day(v-if='false') {{room.price_day}} / 日

  .item(v-if='!contract && $permission.has("basic.view.rooms.empty_days")')
    i.mi(data-tooltip='空置时间', data-position='left center', data-inverted="") event_seat
    span(:data-tooltip='$formatters.date.to_date(last_contract_end)', data-position='right center', data-inverted="")
      | {{empty_days}} 天

  template(v-if='contract')
    .item(v-if='delegated')
      i.mi(data-tooltip='委托到期时间', data-position='left center', data-inverted="") transfer_within_a_station
      span(:data-tooltip='$formatters.date.to_date(contract.transfer_delegation.date_end)', data-position='right center', data-inverted="")
        | 委托: {{days_to_delegation_end}} 天
    .item(v-else-if='!rent_paid_off')
      i.mi(data-tooltip='租金到期时间', data-position='left center', data-inverted="") schedule
      span(:data-tooltip='$formatters.date.to_date(date_expire)', data-position='right center', data-inverted="")
        | {{$formatters.date.expiring_text_from_now(date_expire)}}
    .item(v-else-if='rent_paid_off')
      i.mi(data-tooltip='合同到期时间', data-position='left center', data-inverted="") event_note
      span(:data-tooltip='$formatters.date.to_date(contract.date_end)', data-position='right center', data-inverted="")
        | {{$formatters.date.expiring_text_from_now(contract.date_end)}}

  template(v-if='preorders.length')
    .preorder
</template>

<script>
import { utils } from '../../utils'
import { MixRoom } from '../../mixins'

export default {
  name: 'room-view',
  mixins: [MixRoom],
  props: {
    room: {
      required: true,
      default() {
        return {
          state: 'unavaliable',
          no: '0',
        }
      },
    },
  },
  computed: {
    tracking_notes() {
      return this.room.tracking_notes || []
    },
    tracking_notes_unchecked() {
      return this.tracking_notes.filter(i => !i.state)
    },
    customers() {
      return this.$store.getters.customers_of_contract(this.contract)
    },
    persons() {
      if (this.contract && this.contract._customers)
        return this.contract._customers.length
    },
    preorders() {
      return this.$store.getters.preorders_of_room(this.room.no)
    },
    date_expire() {
      return this.contract.date_expire || this.contract.date_start
    },
    rent_paid_off() {
      return this.date_expire === this.contract.date_end
    },
    empty() {
      return !this.contract
    },
    delegated() {
      return this.contract && this.contract.state === 'delegated'
    },
    contract() {
      return this.room_current_contract(this.room)
    },
    days_to_expired() {
      return this.room_days_to_expired(this.room)
    },
    days_to_delegation_end() {
      if (this.delegated)
        return this.$formatters.date.days_from_now(this.contract.transfer_delegation.date_end)
      return 0
    },
    level() {
      if (this.contract && !this.delegated)
        return utils.ExpiringLevel(this.days_to_expired)
    },
    last_contract_end() {
      if (this.contract)
        return 0
      const contracts = this.$store.getters.contracts_of_room(this.room.no)
      const last = contracts[contracts.length - 1]
      if (!last)
        return 0
      return last.date_expire || last.date_end
    },
    empty_days() {
      if (this.contract)
        return 0
      if (!this.last_contract_end)
        return 0
      return this.$formatters.date.days_in_between(new Date(), this.$moment(this.last_contract_end))
    },
  },
  methods: {
    goto() {
      if (this.contract)
        this.$router.push(`/room/${this.room.no}/contract/${this.contract._id}`)
      else
        this.$router.push(`/room/${this.room.no}`)
    },
  },
}
</script>



// WEBPACK FOOTER //
// RoomView.vue?812f02aa